export default __webpack_public_path__ + "static/media/promo_02.b28c360b.jpg";